import { render } from "./RmaInfos.vue?vue&type=template&id=6ce022c4&scoped=true&ts=true&lang=pug"
import script from "./RmaInfos.vue?vue&type=script&lang=ts"
export * from "./RmaInfos.vue?vue&type=script&lang=ts"

import "./RmaInfos.vue?vue&type=style&index=0&id=6ce022c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce022c4"]])

export default __exports__